/**
 * Provides a way to use console.log so that it shows up in development but not in production.
 * This approach is inspired by https://www.npmjs.com/package/debug. It uses a namespaced approach
 * so that we can toggle debugging on / off for separate features if necessary. For example, to
 * debug the editor, call `debug.editor(...)` like you would normally call `console.log(...)`.
 */
export const debug = {
    editor: (...data: any[]) => {
        // In Next.JS, variables prefixed with `NEXT_PUBLIC_` are available at run time in the
        // browser as well as the server: https://nextjs.org/docs/pages/building-your-application/configuring/environment-variables#bundling-environment-variables-for-the-browser
        // We have opted to leave the `.env.development` file out of .gitignore so that
        // `NEXT_PUBLIC_DEBUG_EDITOR=true` is set during local development by default.
        if (process.env['NEXT_PUBLIC_DEBUG_EDITOR'] === 'true') {
            console.log(...data);
        }
    },
};
